import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId, getBYDUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import HJWSSSP20240314 from '@/views/20240314HJWSSSP';
import HJWSSSPINDEX20240314 from '@/views/20240314HJWSSSPINDEX';
import CQSJDS20240425 from '@/views/20240425CQSJDS';
import NCPJGYSJDS20240516 from '@/views/20240516NCPJGYSJDS';
import DLHMXC20240531 from '@/views/20240531DLHMXC';
import REPORT20240626 from '@/views/20240626REPORT';
import YGXQ20240722 from '@/views/20240722YGXQ';
import BLAYH20240724BLAYH from '@/views/20240724BLAYHBLAYH';
import KHZWZS20240801 from '@/views/20240801KHZWZS';
import CQXF20240807 from '@/views/20240807CQXF';
import KJCX20241009 from '@/views/20241009KJCX';
import FXCQZM20241104 from '@/views/20241104FXCQZM';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 环境卫生随手拍
    HJWSSSP20240314,
    // 环境分类随手拍欢迎前端
    HJWSSSPINDEX20240314,
    // 重庆市农产品加工业设计大赛
    CQSJDS20240425,
    // 重庆市农产品加工业设计大赛
    NCPJGYSJDS20240516,
    // 电靓和美乡村故事大赛
    DLHMXC20240531,
    // 帮帮智能问答
    REPORT20240626,
    // 上游新闻“阳光心桥”专题搭建
    YGXQ20240722,
    // 2024巴黎奥运会
    BLAYH20240724BLAYH,
    // 科幻作文大赛展示专题
    KHZWZS20240801,
    // 寻找重庆最具魅力消费场景
    CQXF20240807,
    // 2024十大重庆科技创新年度人物评选
    KJCX20241009,
    // 2024发现重庆之美
    FXCQZM20241104,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    let res: any = '';
    if (window.location.href.indexOf('BYD0621') > -1) {
      res = await getBYDUnionId({ code });
    } else {
      res = await getUnionId({ code });
    }
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
